/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytTercTo } from '../../models/teryt-terc-to';

export interface ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Params {
  gmi: string;
  pow: string;
  rodz: string;
  woj: string;
  date?: LocalDate;
}

export function apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet(http: HttpClient, rootUrl: string, params: ApiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytTercTo>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet.PATH, 'get');
  if (params) {
    rb.path('gmi', params.gmi, {});
    rb.path('pow', params.pow, {});
    rb.path('rodz', params.rodz, {});
    rb.path('woj', params.woj, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TerytTercTo>;
    })
  );
}

apiWebTerytWojewodztwoWojPowiatyPowGminyGmiRodzGet.PATH = '/api/web/teryt/wojewodztwo/{woj}/powiaty/{pow}/gminy/{gmi}/{rodz}';
